import { createReducer } from 'typesafe-actions';
import { get } from '../../../common/utils/objectUtils';
import { WishListActionType, actions } from './actions';
import { WishlistQueueState, WishlistQueueActionTypes, WISHLIST_QUEUE_UPDATED, WishlistState } from './types';

export const wishlistQueueReducer = (
    state: WishlistQueueState = {
        todo: null,
        simpleSku: null,
    },
    action: WishlistQueueActionTypes
): WishlistQueueState => {
    if (action.type === WISHLIST_QUEUE_UPDATED) {
        return {
            ...state,
            todo: action.payload.todo,
            simpleSku: action.payload.simpleSku,
        };
    }
    return state;
};

const wishlistReducer = createReducer<WishlistState, WishListActionType>({
    isFetching: false,
    didInvalidate: false,
    products: [],
    count: 0,
})
    .handleAction(actions.isFetchingWishListAction, state => ({
        ...state,
        isFetching: true,
    }))
    .handleAction(actions.fetchWishlistSuccessAction, (state, action) => {
        const wishListProducts = get(action.payload.response, 'data.products', []);
        return {
            ...state,
            isFetching: false,
            products: wishListProducts,
            count: wishListProducts.length,
            didInvalidate: false,
        };
    })
    .handleAction(actions.fetchWishlistFailedAction, (state, action) => ({
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: action.payload,
    }))
    .handleAction(actions.addToWishlistFailedAction, (state, action) => {
        const productState = [...state.products.filter(productSku => productSku !== action.payload.simpleSku)];
        return {
            ...state,
            isFetching: false,
            products: productState,
            count: productState.length,
        };
    })
    .handleAction(actions.isRemovingFromWishListAction, (state, action) => {
        const productState = [...state.products.filter(productSku => productSku !== action.payload.simpleSku)];
        return {
            ...state,
            isFetching: true,
            products: productState,
            count: productState.length,
        };
    })
    .handleAction(actions.removeFromWishlistSuccessAction, state => ({
        ...state,
        isFetching: false,
        didInvalidate: false,
    }))
    .handleAction(actions.removeFromWishlistFailedAction, (state, action) => {
        const productState = [action.payload.simpleSku, ...state.products];
        return {
            ...state,
            isFetching: false,
            products: productState,
            count: productState.length,
        };
    })
    .handleAction(actions.isAddingToWishListAction, (state, action) => {
        const productState = [action.payload.simpleSku, ...state.products];
        return {
            ...state,
            isFetching: true,
            products: productState,
            count: productState.length,
        };
    })
    .handleAction(actions.addToWishlistSuccessAction, state => ({
        ...state,
        isFetching: false,
        didInvalidate: false,
    }));

export default wishlistReducer;
